import classNames from 'classnames';

const XMarkIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { className = '', ...attributes } = props;
  const classes = classNames('xmark-icon', className);

  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      className={classes}
      {...attributes}
    >
      <path
        d="M14.8643 14.5304C14.5714 14.8233 14.0965 14.8233 13.8037 14.5304L11.334 12.0607L8.86431 14.5304C8.57141 14.8233 8.09654 14.8233 7.80365 14.5304C7.51075 14.2375 7.51075 13.7626 7.80365 13.4697L10.2733 11L7.80365 8.53037C7.51076 8.23748 7.51076 7.7626 7.80365 7.46971C8.09655 7.17682 8.57142 7.17682 8.86431 7.46971L11.334 9.93937L13.8036 7.4697C14.0965 7.17681 14.5714 7.17681 14.8643 7.4697C15.1572 7.76259 15.1572 8.23747 14.8643 8.53036L12.3946 11L14.8643 13.4697C15.1572 13.7626 15.1572 14.2375 14.8643 14.5304Z"
        fill="#D80027"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.92497 1.34838C6.62824 0.645119 7.58206 0.250031 8.57662 0.250031H14.0913C15.0859 0.250031 16.0397 0.645119 16.743 1.34838L20.9856 5.59102C21.6889 6.29428 22.084 7.24811 22.084 8.24267V13.7574C22.084 14.752 21.6889 15.7058 20.9856 16.409L16.743 20.6517C16.0397 21.3549 15.0859 21.75 14.0913 21.75H8.57662C7.58206 21.75 6.62824 21.3549 5.92497 20.6517L1.68233 16.409C0.979073 15.7058 0.583984 14.752 0.583984 13.7574V8.24267C0.583984 7.24811 0.979073 6.29428 1.68233 5.59102L5.92497 1.34838ZM8.57662 1.75003C7.97989 1.75003 7.40759 1.98708 6.98563 2.40904L2.74299 6.65168C2.32104 7.07364 2.08398 7.64593 2.08398 8.24267V13.7574C2.08398 14.3541 2.32104 14.9264 2.74299 15.3484L6.98563 19.591C7.40759 20.013 7.97989 20.25 8.57662 20.25H14.0913C14.6881 20.25 15.2604 20.013 15.6823 19.591L19.925 15.3484C20.3469 14.9264 20.584 14.3541 20.584 13.7574V8.24267C20.584 7.64593 20.3469 7.07364 19.925 6.65168L15.6823 2.40904C15.2604 1.98708 14.6881 1.75003 14.0913 1.75003H8.57662Z"
        fill="#D80027"
      />
    </svg>
  );
};

export default XMarkIcon;
